import { BankIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Section } from "views/applications-id-report/components/Section";
import { SectionIcon } from "../components/SectionIcon";
import { LenderCard } from "../components/LenderCard";
import { SelectedLender } from "../types";

export const SelectedLendersSlice = ({
  lenders
}: {
  lenders: SelectedLender[];
}) => (
  <Section
    sectionTitle="Selected lenders"
    icon={<SectionIcon icon={BankIcon} />}
  >
    <div className="space-y-2">
      {lenders.map((lender) => (
        <LenderCard key={lender.id} {...lender} />
      ))}
    </div>
  </Section>
);
